<template>
    <!-- Global notification live region, render this permanently at the end of the document -->
     
    <modal-jetstream :show="show" :max-width="'2xl'" z-index-class="z-[60]">
        <div class="rounded-md overflow-x-auto m-2 mb-4">
            <div class="overflow-x-auto">
                <div class="align-middle inline-block min-w-full">
                    <div class="bg-white overflow-hidden pt-4">
                        <div class="relative max-w-xl mx-auto">
                            <svg class="absolute left-full transform translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                                <defs>
                                    <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                        <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                            </svg>
                            <svg class="absolute right-full bottom-0 transform -translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                                <defs>
                                    <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                        <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                            </svg>
                            <div class="text-center">
                                <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    {{ heading }}
                                </h2>
                            </div>
                            <div class="mt-6">
                                <alert-card :type="'info'">
                                    <p class="text-center">
                                        {{ noticeText }}
                                    </p>
                                </alert-card>
                                <form @submit.prevent="storeCard" class="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-8">
                                    <div class="sm:col-span-2">
                                        <div class="flex justify-between space-x-4 mt-4">
                                            <div class="w-1/2">
                                                <label for="first_name" class="block text-sm font-medium text-gray-700">First name</label>
                                                <div class="mt-1">
                                                    <input type="text" v-model="cardForm.first_name" :error="cardForm.errors.first_name" id="first_name" autocomplete="given_name" v-bind:class="(cardForm.errors.first_name)?'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-red-500 rounded-md':'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-gray-300 rounded-md'">
                                                    <p v-text="cardForm.errors.first_name" class="text-red-500"></p>
                                                </div>
                                            </div>
                                            <div class="w-1/2">
                                                <label for="last_name" class="block text-sm font-medium text-gray-700">Last name</label>
                                                <div class="mt-1">
                                                    <input type="text" v-model="cardForm.last_name" :error="cardForm.errors.last_name" id="last_name" autocomplete="family-name" v-bind:class="(cardForm.errors.last_name)?'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-red-500 rounded-md':'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-gray-300 rounded-md'">
                                                    <p v-text="cardForm.errors.last_name" class="text-red-500"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sm:col-span-2">
                                        <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                                        <div class="mt-1">
                                            <input id="email" v-model="cardForm.email" :error="cardForm.errors.email" type="email" autocomplete="email" v-bind:class="(cardForm.errors.email)?'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-red-500 rounded-md':'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-gray-300 rounded-md'">
                                            <p v-text="cardForm.errors.email" class="text-red-500"></p>
                                        </div>
                                    </div>
                                    <div class="sm:col-span-2">
                                        <div class="">
                                            <label class="block text-sm font-medium text-gray-700">Payment method</label>
                                            <div :id="paymentElementId" class="mt-1"></div>
                                        </div>
                                        <p class="text-red-500 text-sm">{{ stripeError }}</p>
                                    </div>
                                    <div class="sm:col-span-2 mt-4 flex gap-4">
                                        <button type="button" @click="$emit('close')" :disabled="!isButtonActive"
                                            class="flex-1 bg-white py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            Close
                                        </button>
                                        <form-button id="purchase-btn" :form="cardForm" :disabled="!isButtonActive"
                                            :data-secret="stripe_data.setup_intent.client_secret"
                                            class="flex-1 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-rent-risk-blue-400 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400 disabled:bg-indigo-100"
                                            type="submit">
                                            {{ confirmButtonText }}
                                        </form-button>
                                    </div>
                                    <div class="sm:col-span-2 text-center">
                                        <span class="text-xs tracking-tight text-gray-500">
                                            By clicking {{ confirmButtonText }}, you agree to our <a :href="route('privacy-policy')" target="_blank" class="underline">Privacy Policy</a> and <a :href="route('terms-and-conditions')" target="_blank" class="underline">Terms and Conditions</a>.
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </modal-jetstream>
</template>

<script>
import ModalJetstream from "@/Jetstream/Modal.vue";
import { computed, markRaw, useId } from "vue";
import FormButton from '@/Shared/FormButton.vue'
import AlertCard from "@/Shared/AlertCard.vue";
import axios from "axios";

export default {
    components: {
        ModalJetstream,
        FormButton,
        AlertCard,
    },
    props: {
        show: Boolean,
        stripe_data: Object,
        confirmButtonText: {
            type: String,
            default: 'Add Card',
        },
        heading: {
            type: String,
            default: 'Card Information',
        },
        noticeText: {
            type: String,
            default: 'This card will be used for active RentRisk subscriptions.',
        },
        // Only the Billing page sets this. When true the backend settles any open invoice on a
        // past_due/unpaid subscription once the card is saved; every other card-capture flow
        // leaves it false so it never silently charges.
        settleOpenInvoices: {
            type: Boolean,
            default: false,
        },
        // Only the Billing "Update card" flow sets this. When true the backend replaces the
        // landlord's existing card (detach + delete, then persist the new one) in one request;
        // elsewhere it stays false so adding a second card is still rejected.
        replaceExisting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cardForm: this.$inertia.form({
                first_name: this.stripe_data.first_name,
                last_name: this.stripe_data.last_name,
                email: this.stripe_data.user?.email,
                card: null,
                setup_intent: null,
                token: null,
            }),
            isButtonActive: true,
            stripeAPIToken: this.stripe_data.publishable_key,
            stripe: null,
            elements: null,
            paymentElement: null,

            stripeError: '',
        }
    },
    watch: {
        show(newVal) {
            if (newVal === true) {
                this.paymentElement?.unmount();
                this.includeStripe('js.stripe.com/v3/', () => {
                    this.configureStripe();
                });
            }
        }
    },
    mounted() {
    },
    setup(props) {
        const publishable_key = props.stripe_data.publishable_key;
        const setup_intent = props.stripe_data.setup_intent;
        const user = computed(() => usePage().props.user);
        // Some pages render two of these popups, so each mounts its Payment Element on its own id.
        const paymentElementId = `add-card-payment-element-${useId()}`;
        return {user, publishable_key, setup_intent, paymentElementId};
    },
    methods: {
        // Stripe
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = 'https://' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

        /*
            Configures Stripe by setting up the elements and
            creating the card element.
        */
        configureStripe(){
            this.stripe = Stripe( this.stripeAPIToken );
            this.elements = this.stripe.elements({
                clientSecret: this.stripe_data.setup_intent.client_secret,
            });

            // 86bckgczc: one Payment Element instead of split card fields, so Apple Pay and
            // Google Pay are offered next to the card. They ride on the SetupIntent's `card`
            // type and save as an ordinary card. Link is off, matching StripeForm (86bcfenhv).
            // markRaw: keep Vue's reactivity proxy off the Stripe element.
            this.paymentElement = markRaw(this.elements.create('payment', {
                wallets: { link: 'never' },
                defaultValues: {
                    billingDetails: {
                        name: `${this.cardForm.first_name ?? ''} ${this.cardForm.last_name ?? ''}`.trim(),
                        email: this.cardForm.email,
                    },
                },
            }));
            this.paymentElement.mount(`#${this.paymentElementId}`);
        },
        async storeCard() {
            if(!this.cardForm.first_name || !this.cardForm.last_name || !this.cardForm.email) {
                this.cardForm.errors.first_name = !this.cardForm.first_name ? 'The first name is required.' : null;
                this.cardForm.errors.last_name = !this.cardForm.last_name ? 'The last name is required.' : null;
                this.cardForm.errors.email = !this.cardForm.email ? 'The email is required.' : null;
                return false;
            }
            this.isButtonActive = false;
            this.stripeError = '';
            try {
                // Nothing may be awaited before confirmSetup: Apple Pay only opens its sheet
                // when Stripe is called straight from the click.
                const { setupIntent, error } = await this.stripe.confirmSetup({
                    elements: this.elements,
                    redirect: 'if_required',
                    confirmParams: {
                        return_url: route('customer-payment-method-created'),
                        payment_method_data: {
                            billing_details: {
                                name: this.cardForm.first_name + ' ' + this.cardForm.last_name,
                                email: this.cardForm.email,
                            },
                        },
                    },
                });

                if (error) {
                    this.isButtonActive = true;
                    // Show the error inside this popup; a page can render two, so no shared DOM id.
                    this.stripeError = error.message;
                } else {
                    axios.post(route('customer-payment-method-created'), { 
                        setup_intent: setupIntent.id,
                        request_type: 'axios',
                        settle_open_invoices: this.settleOpenInvoices,
                        replace_existing: this.replaceExisting,
                    })
                    .then(response => {
                        // handle the response as needed
                        if(response.data.status) {
                            this.$emit('card-added', {
                                payment_method: response.data.payment_method,
                                success: true,
                                // 86bcd9hgt: carries the step-6 "Card saved. Paid N invoice(s)…"
                                // message so the Billing page can flash exactly what was charged.
                                message: response.data.message,
                            });
                        } else {
                            this.isButtonActive = true;
                            this.stripeError = response.data.message || 'Failed to attach payment method. Please try again.';
                            // Emit card-added event with failure status to close the popup
                            this.$emit('card-added', {
                                payment_method: null,
                                success: false,
                                error: response.data.message || 'Failed to attach payment method. Please try again.'
                            });
                        }
                    })
                    .catch(error => {
                        this.isButtonActive = true;
                        console.error('Card attachment error:', error);
                        this.stripeError = error.response?.data?.message || 'Failed to attach payment method. Please try again.';
                        // Emit card-added event with failure status to close the popup
                        this.$emit('card-added', {
                            payment_method: null,
                            success: false,
                            error: error.response?.data?.message || 'Failed to attach payment method. Please try again.'
                        });
                    });
                }
            } catch (error) {
                this.isButtonActive = true;
            }
        },
    },
}
</script>
